// Demandes d'achat : « mes demandes » pour chacun ; toutes, à traiter en premier, pour le responsable achats.
import React, { useEffect, useState } from 'react';
import {
  Alert, Button, Chip, Grid, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Typography,
} from '@mui/material';
import { AddOutlined, AssignmentLateOutlined, PlaylistAddCheckOutlined } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout';
import { Kpi, Panel } from '../../components/ui';
import { daAPI } from '../../services/api';
import { apiError, dateFr } from '../../utils/format';
import { DA_STATUS } from './status';
import { tokens } from '../../theme';

const DemandesAchat = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [d, setD] = useState(null);
  const [tab, setTab] = useState('');
  const [error, setError] = useState('');
  const [info, setInfo] = useState(location.state?.info || '');

  useEffect(() => {
    const params = tab === 'miennes' ? { miennes: 1 } : tab ? { statut: tab } : {};
    daAPI.list(params).then((r) => setD(r.data)).catch((e) => setError(apiError(e)));
  }, [tab]);

  return (
    <Layout title="Demandes d'achat" plain
      actions={<Button variant="contained" startIcon={<AddOutlined />} onClick={() => navigate('/demandes-achat/nouvelle')}>Nouvelle demande</Button>}>
      {info && <Alert severity="success" sx={{ mb: 2 }} onClose={() => setInfo('')}>{info}</Alert>}
      {error && <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>{error}</Alert>}
      {d?.lecteur && (
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={6} md={3}><Kpi compact icon={AssignmentLateOutlined} tint="amber" label="À traiter" value={d.compteurs.a_traiter} sub="Demandes soumises" onClick={() => setTab('SOUMISE')} /></Grid>
          <Grid item xs={6} md={3}><Kpi compact icon={PlaylistAddCheckOutlined} tint="navy" label="Approuvées" value={d.compteurs.a_commander} sub="À transformer en commande" onClick={() => setTab('APPROUVEE')} /></Grid>
        </Grid>
      )}
      {!d?.lecteur && d && (
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          Vos demandes d'achat et leur suivi. Le responsable des achats les approuve puis passe commande auprès du fournisseur.
        </Typography>
      )}
      <Panel flush>
        {d?.lecteur && (
          <Tabs value={tab} onChange={(e, v) => setTab(v)} variant="scrollable" sx={{ px: 1, borderBottom: '1px solid', borderColor: 'divider' }}>
            <Tab value="" label="Toutes" /><Tab value="SOUMISE" label="À traiter" /><Tab value="APPROUVEE" label="Approuvées" />
            <Tab value="COMMANDEE" label="En commande" /><Tab value="miennes" label="Mes demandes" />
          </Tabs>
        )}
        <TableContainer sx={{ overflowX: 'auto' }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>N°</TableCell><TableCell>Date</TableCell>{d?.lecteur && <TableCell>Demandeur</TableCell>}
                <TableCell>Articles</TableCell><TableCell>Besoin pour le</TableCell><TableCell>Statut</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {d?.demandes.map((r) => (
                <TableRow key={r.id} hover sx={{ cursor: 'pointer' }} onClick={() => navigate(`/demandes-achat/${r.id}`)}>
                  <TableCell sx={{ fontFamily: tokens.mono, fontWeight: 600, whiteSpace: 'nowrap' }}>{r.numero}</TableCell>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>{dateFr(r.created_at)}</TableCell>
                  {d.lecteur && <TableCell>{r.demandeur}{r.service ? <Typography component="span" sx={{ display: 'block', fontSize: 12.5, color: 'text.secondary' }}>{r.service}</Typography> : null}</TableCell>}
                  <TableCell sx={{ maxWidth: 380 }}>
                    <Typography sx={{ fontSize: 14, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.articles}</Typography>
                    <Typography sx={{ fontSize: 12.5, color: 'text.secondary', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.motif}</Typography>
                  </TableCell>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>{r.date_besoin ? dateFr(r.date_besoin) : '—'}</TableCell>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>
                    <Chip size="small" label={DA_STATUS[r.statut].label} color={DA_STATUS[r.statut].color} variant={r.statut === 'SOUMISE' ? 'filled' : 'outlined'} />
                    {r.urgence === 'URGENTE' && <Chip size="small" label="Urgent" color="error" sx={{ ml: 0.5 }} />}
                    {r.bc_numero && <Typography sx={{ fontSize: 12, color: 'text.secondary', fontFamily: tokens.mono, mt: 0.25 }}>{r.bc_numero}</Typography>}
                  </TableCell>
                </TableRow>
              ))}
              {d && d.demandes.length === 0 && (
                <TableRow><TableCell colSpan={6} align="center" sx={{ py: 5, color: 'text.secondary' }}>
                  Aucune demande. Cliquez « Nouvelle demande » pour demander un achat (matériel, matière, outillage…).
                </TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Panel>
    </Layout>
  );
};

export default DemandesAchat;
